import { twMerge } from 'tailwind-merge';

interface FormFieldProps {
  containerRef?: React.RefObject<HTMLDivElement>;
  text: string | React.ReactNode;
  textLeftIcon?: React.ReactNode;
  subText?: string | React.ReactNode;
  required?: boolean;
  children: React.ReactNode;
  containerClassName?: string;
  textOuterWrapperClassName?: string;
  textWrapperClassName?: string;
  textClassName?: string;
  subTextClassName?: string;
}

export const FormField = ({
  containerRef,
  text,
  textLeftIcon,
  subText,
  required,
  children,
  containerClassName,
  textOuterWrapperClassName,
  textWrapperClassName,
  textClassName,
  subTextClassName,
}: FormFieldProps) => {
  return (
    <div
      ref={containerRef}
      className={twMerge(
        'flex flex-wrap gap-10 max-md:gap-1.5',
        containerClassName,
      )}
    >
      <div
        className={twMerge(
          'w-[270px] max-md:w-full',
          textOuterWrapperClassName,
        )}
      >
        <div className="flex gap-1">
          {textLeftIcon}
          <div className={twMerge('text-sm text-wrap', textWrapperClassName)}>
            <span
              // className={twMerge('text-gray-5B5B5B', textClassName)}
              // className={twMerge('text-black/70 font-medium', textClassName)}
              className={twMerge(
                'text-slate-500 font-medium leading-tight',
                textClassName,
              )}
            >
              {text}
            </span>{' '}
            {required && (
              <span className="text-red-FF2929 font-semibold">*</span>
            )}
          </div>
        </div>
        {subText && (
          <div
            className={twMerge(
              // 'mt-[1px] text-gray-5B5B5B/70 text-2sm italic',
              'mt-[1px] text-gray-600 text-2sm italic',
              subTextClassName,
            )}
          >
            {subText}
          </div>
        )}
      </div>
      <div className="flex flex-1 max-md:[&>*:first-child]:mt-0">
        {children}
      </div>
    </div>
  );
};
